import { useTranslation } from "lib/i18n/translation"
import { CGV } from "components/modals"

export default ({}) => {
	const { c } = useTranslation("common")

	return (
		<section>
			<h2 className="section-title">{c("cgvu")}</h2>
			<CGV />
		</section>
	)
}